import cx from 'classnames'
import type { MouseEventHandler } from 'react'

import { IconButton } from '../../actions/iconButton/IconButton'
import { Th } from '../table/Table'
import type { Column } from './createColumnDefiner'
import { ColumnFilter } from './filters/ColumnFilter'
import type { ColumnFilterState } from './useFilterState'
import type { ColumnSortingState } from './useSortingState'

type Props<T> = {
  column: Column<T>
  sortingState: ColumnSortingState | null
  filterState: ColumnFilterState<T> | null
  onClick: undefined | MouseEventHandler
  onStateChanged: (state: ColumnFilterState<T>) => void
}

export const SortableTableHeader = <T,>({
  column,
  sortingState,
  filterState,
  onClick,
  onStateChanged,
}: Props<T>) => (
  <Th
    className={cx({
      'cursor-pointer': column.sortable !== false,
      'whitespace-nowrap': column.noWrap,
    })}
    style={column.width ? { width: column.width } : undefined}
    role={column.sortable !== false ? 'button' : ''}
  >
    <div
      className={cx('flex items-end', {
        'float-right': column.alignment === 'right',
      })}
    >
      <div className="flex grow items-end" onClick={onClick}>
        <div className="grow">{column.heading}</div>
        {sortingState && (
          <IconButton
            tip={null}
            iconName={sortingState.isDescending ? 'ArrowUp' : 'ArrowDown'}
            isSelected={false} // hack not to have primary color
            className="-m-1"
          />
        )}
        {!!sortingState?.priority && <sup>{sortingState.priority}</sup>}
      </div>
      {filterState && (
        <ColumnFilter state={filterState} onStateChanged={onStateChanged} />
      )}
    </div>
  </Th>
)
